import { render, staticRenderFns } from "./upload-dialog.vue?vue&type=template&id=1c05d23a"
import script from "./upload-dialog.vue?vue&type=script&lang=js"
export * from "./upload-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports